import { supabase } from "./supabase";
import { isNotification, startNotificationSync, type NotificationRemote, type OsNotification } from "./notifications";
export function connectNotificationInbox(ownerId: string) { return startNotificationSync(ownerId, supabase && ownerId ? notificationRemote(ownerId) : null); }
async function rpc(name: string, args?: Record<string, unknown>) {
  if (!supabase) throw new Error("Notificações sem conexão.");
  const { data, error } = await supabase.rpc(name, args);
  if (error) throw new Error("Não foi possível sincronizar as notificações.");
  return data;
}
export const notificationRemote = (ownerId: string): NotificationRemote => ({
  async list() {
    const rows: unknown = await rpc("list_os_notifications", { p_expected_owner: ownerId });
    if (!Array.isArray(rows)) throw new Error("Resposta de notificações inválida.");
    return rows.map(parseNotification);
  },
  async publish(item) {
    await rpc("publish_os_notification", { p_id: item.id, p_event_key: item.eventKey, p_title: item.title,
      p_message: item.message, p_kind: item.kind, p_app_path: item.appPath ?? null, p_expected_owner: ownerId });
  },
  async acknowledge(keys, dismiss) { await rpc("acknowledge_os_notifications", { p_event_keys: keys, p_dismiss: dismiss, p_expected_owner: ownerId }); },
});
export function parseNotification(value: unknown): OsNotification {
  if (!value || typeof value !== "object") throw new Error("Notificação inválida.");
  const row = value as Record<string, unknown>;
  const item = { id: row.id, eventKey: row.event_key, title: row.title, message: row.message, kind: row.kind,
    createdAt: typeof row.created_at === "string" ? Date.parse(row.created_at) : NaN,
    read: Boolean(row.read_at), dismissed: Boolean(row.dismissed_at), ...(row.app_path ? { appPath: row.app_path } : {}) };
  if (!isNotification(item)) throw new Error("Notificação inválida.");
  return item;
}
